var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-card"},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[_c('div',{key:_vm.value,staticClass:"flip-number"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }